import { apiGet } from '../../API/httpCommon';
import { useEffect, useState } from 'react';
import { ProductModel } from '../../Model/ProductModel';
import config from '../../config.json';
import { debug } from 'console';
import Spinner from '../Spinner/Spinner';
import Product from '../product/Product';
import './Index.css';

const Index = (props : any) => {

    const [ProductList, setProductList] = useState<ProductModel[]>([]);
    const [LatestEditiontList, setLatestEditiontList] = useState<ProductModel[]>([]);
    const [ProductCategoryList, setProductCategoryList] = useState<ProductModel[]>([]);
    const [ProductCategoryListMedical, setProductCategoryListMedical] = useState<ProductModel[]>([]);
    const [ProductCategoryListTaxation, setProductCategoryListTaxation] = useState<ProductModel[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const[CurrentYear, setCurrentYear] = useState<any>(null);


    useEffect(function () {

        getLatestProduct();
        getLatestEditionBook();
        getProductByCategory('Engineering Books');

        setCurrentYear(new Date().getFullYear());

        getProductByCategoryMedical();
        getProductByCategoryTaxation();

        const userAgent = navigator.userAgent;

    }, [])


    const getLatestProduct = () => {
        setIsLoading(true);
        apiGet("api/Home/GetLatestProduct?ProductName=Books").then((res: any) => {
            setProductList(res?.Data);
            setIsLoading(false);
        });
    }


    const getLatestEditionBook = () => {
          
        setIsLoading(true);
        apiGet("api/Home/GetLatestEditionBook").then((res: any) => {
            
            setLatestEditiontList(res?.Data);
            setIsLoading(false);
        });
    }


    const getProductByCategory = (category: any) => {
        setIsLoading(true);
        
        apiGet(`api/Home/GetProductByCategory?Category=${encodeURIComponent(category)}`).then((res: any) => {
            setProductCategoryList(res?.Data);
            setIsLoading(false);
        });
    }

    const getProductByCategoryMedical = () => {
        
        setIsLoading(true);
        apiGet(`api/Home/GetProductByCategory?Category=${encodeURIComponent('Medical Books')}`).then((res: any) => {
          
            setProductCategoryListMedical(res?.Data);
            setIsLoading(false);
        });
    }

    const getProductByCategoryTaxation = () => {
        
        setIsLoading(true);
        apiGet(`api/Home/GetProductByCategory?Category=${encodeURIComponent('Taxation Books')}`).then((res: any) => {
           
            setProductCategoryListTaxation(res?.Data);
            setIsLoading(false);
        });
    }


    const myStyle = {
       backgroundImage: "url('/assets/img/banner-book.jpg');"
      };



    return (<>
   
   {(isLoading && <Spinner></Spinner>)} 

        {/* <section className="slideshow-container">
            <div className="mySlides">
                <a href='https://samsungepp.machwan.com/' target="_blank">
                    <img src="assets/img/banner/samsung-banner.jpg" style={{ width: "100%" }} />
                </a>
            </div>
            <div className="mySlides">
                <img src="assets/img/banner/Meripustak-banner.jpg" style={{ width: "100%" }} />
            </div>
             <a className="prev" id='btnPreviousSlide' >❮</a>
            <a className="next" id='btnNextSlide' >❯</a> 
        </section> */}


<section className="slideshow-container">
<div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
         <a href='https://samsungepp.machwan.com/' target="_blank">
       <img src="assets/img/banner/samsung-banner.jpg" className="d-block w-100" alt="..."/>
       </a>
    </div>
    <div className="carousel-item">
      <img src="assets/img/banner/Meripustak-banner.jpg" className="d-block w-100" alt="..."/>
    </div>
    


  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
</section>





        {/* <section className="about-section fix section-padding mt-10 bg-light">
        <div className="container">
            <div className="about-wrapper">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-12">
                        <div className="about-content text-center">
                            <div className="section-title">
                                <h3 className="wow fadeInUp" data-wow-delay=".3s" style={{visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp;"}}>Your Trusted Source for Knowledge and Learning</h3>
                            </div>
                            <p className="mt-10 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>
                              Discover a world of expertise at your fingertips. At MeriPustak, we’re committed to empowering students, professionals, and lifelong learners with authentic, high-quality resources delivered right to your door.
                            </p>
                           
                        </div>
                    </div>
                </div>
				 <div className="row g-4 align-items-center mt-10">
                    <div className="col-lg-12">
                        <div className="about-content text-center">
                            <div className="section-title">
                                <h3 className="wow fadeInUp" data-wow-delay=".3s" style={{visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp;"}}>Why Choose MeriPustak?</h3>
                            </div>
                            <p className="mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>
                              What Sets Us Apart
                            </p>
                        </div>
                    </div>
                </div>
				<div className="row g-4 align-items-center">
                    <div className="col-lg-4">
                        <div className="about-content text-center team-box-items">
                            <div className="section-title">
                                <h4 className="wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>100% Genuine</h4>
                            </div>
                            <p className="mt-10 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>
                             We guarantee authenticity in every resource you receive.<br/><br/>
                            </p>
                        </div>
                    </div>
					 <div className="col-lg-4">
                        <div className="about-content text-center team-box-items">
                            <div className="section-title">
                                <h4 className="wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>Fast &amp; Reliable Delivery</h4>
                            </div>
                            <p className="mt-10 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>
                             Get your orders on time, anywhere in India.<br/><br/><br/>
                            </p>
                           
                        </div>
                    </div>
					
					 <div className="col-lg-4">
                        <div className="about-content text-center team-box-items">
                            <div className="section-title">
                                <h4 className="wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>Curated for Professionals &amp; Enthusiasts</h4>
                            </div>
                            <p className="mt-10 mt-md-0 wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp;"}}>
                             Technical &amp; Professional books, traditional Indian utensils, and heritage products for professionals and enthusiasts.
                            </p>
                           
                        </div>
                    </div>
                </div>
				
				
				
            </div>
        </div>
    </section> */}


        
{/* <section className="cta-banner-section fix section-padding pt-0">
        <div className="container">
			<div className="row">
				<div className="col-md-6">
					<div className="cta-banner-wrapper  bg-cover bg-Cover-Book">
					<div className="home-bg section-padding">
						<div className="cta-content text-center">
							<h5>START EXPLORING</h5>
							<h2 className="mb-10 wow fadeInUp" data-wow-delay=".3s">THE BOOK STORE</h2>
							<p> Discover 100% Original & New Books at Meripustak.com</p><br></br>
							<a href="/Books/cid-10001" className="theme-btn wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp", background:"#5e17eb", color:"#ffffff"}}>Shop Now
                            </a>
						</div>
					</div>
					</div>
				</div>
				<div className="col-md-6">
					<div className="cta-banner-wrapper bg-cover bg-Cover-HomeStore">
						<div className="home-bg section-padding">
						<div className="cta-content text-center">
							<h5>START EXPLORING</h5>
							<h2 className="mb-10 wow fadeInUp" data-wow-delay=".3s">THE HOME STORE</h2>
								<p style={{color:"#ffffff"}}>Introducing Our New Home Section: A Curated Collection of Authentic Indian Traditional Products, Featuring Exquisite Utensils and More</p>
							<a href="/HomeStore/cid-11374" className="theme-btn wow fadeInUp" data-wow-delay=".5s"
								style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp", background:"#5e17eb", color:"#ffffff"}}>Shop Now 
                                </a>
						</div>
						</div>
					</div>
				</div>
				
			</div>
           
        </div>
    </section> */}

        <section className="shop-section section-padding fix pt-0 book-catagories-section">
            <div className="container">
                <div className="section-title-area" style={{paddingTop:"15px"}}>
                    <div className="section-title">
                        <h2 className="wow fadeInUp" data-wow-delay=".3s">Latest Products</h2>
                    </div>

                </div>
                <div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>
                <div className="swiper book-slider ">
                    <div className="swiper-wrapper">
                        <Product ProductList={ProductList}></Product>
                    </div>
                </div>
            </div>
        </section>

       <section className="shop-section section-padding fix  book-catagories-section" style={{ background: "#f3f3f3" }}>
            <div className="container">
                <div className="section-title-area">
                    <div className="section-title">
                        <h2 className="wow fadeInUp" data-wow-delay=".3s">{CurrentYear} EDITION</h2>
                    </div>
                </div>
                <div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>
                <div className="swiper book-slider " style={{ background: "#ffffff" }}>
                    <div className="swiper-wrapper">

                    <Product ProductList={LatestEditiontList}></Product>

                    </div>
                </div> 
            </div>
        </section>

        <section className="shop-section section-padding fix">
            <div className="container">
                <div className="section-title-area">
                    <div className="section-title">
                        <h2 className="wow fadeInUp" data-wow-delay=".3s">Explore Catagories</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="book-shop-wrapper">
                            <div className="cta-shop-box text-center" style={{ background: "#adddb9" }}>
                                <h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
                                <h2 className="wow fadeInUp" data-wow-delay=".2s">
                                    TAXATION<br />
                                    BOOKS
                                </h2>
                                <img src="/assets/img/taxataion.webp" alt="shape-img" style={{ width: "90px", marginBottom: "10px" }} /><br />
                                <a href="/Taxation-Books/cid-10029" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s" style={{ background: "#5e17eb", color: "#ffffff" }}>View More <i
                                    className="fa-solid fa-arrow-right-long"></i></a>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="book-shop-wrapper">
                            <div className="cta-shop-box text-center" style={{ background: "#f7a072" }}>
                                <div className="row">
                                    <div className="col-md-8">
                                        <h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
                                        <h2 className="wow fadeInUp" data-wow-delay=".2s">
                                            LEGAL
                                            BOOKS
                                        </h2>
                                    </div>
                                    <div className="col-md-4">
                                        <a href="/Legal-Books/cid-10031" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s">View More <i
                                            className="fa-solid fa-arrow-right-long"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="book-shop-wrapper">
                            <div className="cta-shop-box text-center" style={{ background: "#ffa857" }}>
                                <div className="row">
                                    <div className="col-md-4">
                                        <a href="/Science/cid-11280" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s">View More <i
                                            className="fa-solid fa-arrow-right-long"></i></a>
                                    </div>
                                    <div className="col-md-8">
                                        <h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
                                        <h2 className="wow fadeInUp" data-wow-delay=".2s">
                                            SCIENCE
                                            BOOKS
                                        </h2>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="book-shop-wrapper">
                            <div className="cta-shop-box text-center" style={{ background: "#d7eaf8" }}>
                                <h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
                                <h2 className="wow fadeInUp" data-wow-delay=".2s">
                                    MEDICAL<br />
                                    BOOKS
                                </h2>
                                <img src="/assets/img/medical.webp" alt="shape-img" style={{ width: "100px", marginBottom: "10px" }} /><br />
                                <a href="/Medical-Books/cid-10002" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s" style={{ background: "#5e17eb", color: "#ffffff" }}>View More <i
                                    className="fa-solid fa-arrow-right-long"></i></a>

                            </div>
                        </div>
                    </div>
                </div>




            </div>
        </section>

      
        <section className="shop-section section-padding fix  book-catagories-section">
            <div className="container">
                <div className="section-title-area">
                    <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist" style={{ margin: "0 auto" }}>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="pills-Engineering-tab" data-bs-toggle="pill"
                                type="button" role="tab"
                                aria-controls="pills-Engineering" aria-selected="true" onClick={() => getProductByCategory('Engineering Books')}>Engineering Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Math-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Math" type="button" role="tab"
                                aria-controls="pills-Math" aria-selected="false" onClick={() => getProductByCategory('Mathematics & Statistics Books')}>Mathematics & Statistics Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link " id="pills-Management-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Management" type="button" role="tab"
                                aria-controls="pills-Management" aria-selected="false"  onClick={() => getProductByCategory('Management')}>Management</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-UPSC-tab"
                                data-bs-toggle="pill" data-bs-target="#pills-UPSC"
                                type="button" role="tab" aria-controls="pills-UPSC"
                                aria-selected="false"   onClick={() => getProductByCategory('UPSC / PCS')}>UPSC / PCS </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Nursing-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Nursing" type="button" role="tab"
                                aria-controls="pills-Nursing" aria-selected="false" onClick={() => getProductByCategory('Nursing Books')}>Nursing Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Kids-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Kids" type="button" role="tab"
                                aria-controls="pills-Kids" aria-selected="false"  onClick={() => getProductByCategory('Kids Books')}>Kids Books</button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-Travel-tab" data-bs-toggle="pill"
                                data-bs-target="#pills-Travel" type="button" role="tab"
                                aria-controls="pills-Travel" aria-selected="false" onClick={() => getProductByCategory('Travel Books')}>Travel Books</button>
                        </li>
                    </ul>
                </div>
                <div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>

                <div className="swiper book-slider ">
                    <div className="swiper-wrapper">
                    <Product ProductList={ProductCategoryList}></Product>
                    </div>
                </div>
            </div>
        </section>


<section className="cta-banner-section fix section-padding pt-0">
        <div className="container">
			<div className="row">
				<div className="col-md-6">
					 <div className="cta-banner-wrapper section-padding bg-cover" style={{background: "#01bf63"}}>
						<div className="row">
						<div className="col-md-4">
						<div className="book-shape">
								<img src="assets/img/banner/Galaxy-Book5-Series.jpg" alt="shape-img" style={{width:"220px"}}/>
							</div>
						</div>
						<div className="col-md-8">
						<div className="cta-content text-left">
								
								<h2 className="mb-10 wow fadeInUp" data-wow-delay=".3s" style={{fontSize: "28px;",  color: "rgb(255, 255, 255)", visibility: "visible",  animationDelay: "0.3s", animationName: "fadeInUp"}}>Galaxy Book5 Series For Work</h2>
									<p style={{color:"#ffffff"}}>Meet the All-New Galaxy Book5 Series — Born AI. Built Premium.</p>
									
								<a href="https://forms.gle/xFL3XAUP3jqPHFu7A" target="_blank" className="theme-btn wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s",  animationName: "fadeInUp",  background: "rgb(255, 255, 255)",  color: "rgb(1, 191, 99)"}}>Book a consultation <i className="fa-solid fa-arrow-right-long"></i></a>
							</div>
						</div>
						</div>		
					</div>
				</div>
				<div className="col-md-6">
					 <div className="cta-banner-wrapper section-padding bg-cover" style={{background: "#5e17eb"}}>
					 <div className="row">
						
						<div className="col-md-9">
						<div className="cta-content text-left">
							<h2 className="mb-10 wow fadeInUp" data-wow-delay=".3s" style={{fontSize: "26px", color: "rgb(255, 255, 255)",  visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp"}}>Roll out Samsung Employee Purchase Program (EPP) in your organization</h2>
								<p style={{color:"#ffffff"}}>Zero-cost rollout • Corporate-only store</p>	
							<a href="https://samsungepp.machwan.com/" className="theme-btn wow fadeInUp" data-wow-delay=".5s" style={{visibility: "visible", animationDelay: "0.5s", animationName: "fadeInUp", background: "rgb(255, 255, 255)", color: "rgb(94, 23, 235)"}}>Fill the request form<i className="fa-solid fa-arrow-right-long"></i></a>
						</div>
						</div>
						<div className="col-md-3">
						<div className="book-shape" style={{right: "0"}}>
							<img src="assets/img/banner/samsungepp.jpg" alt="shape-img" style={{width:"220px"}}/>
						</div>
						</div>
						</div>
						
										
					</div>
				</div>
			</div>
           
        </div>
    </section>


 <section className="shop-section section-padding fix pt-0 book-catagories-section">
            <div className="container">
                <div className="section-title-area" style={{paddingTop:"15px"}}>
                    <div className="section-title">
                        <h2 className="wow fadeInUp" data-wow-delay=".3s">Medical Books</h2>
                    </div>

                </div>
                <div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>
                <div className="swiper book-slider ">
                    <div className="swiper-wrapper">
                        <Product ProductList={ProductCategoryListMedical}></Product>
                    </div>
                </div>
            </div>
        </section>



 <section className="shop-section section-padding fix pt-0 book-catagories-section">
            <div className="container">
                <div className="section-title-area" style={{paddingTop:"15px"}}>
                    <div className="section-title">
                        <h2 className="wow fadeInUp" data-wow-delay=".3s">Taxation Books</h2>
                    </div>

                </div>
                <div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>
                <div className="swiper book-slider ">
                    <div className="swiper-wrapper">
                        <Product ProductList={ProductCategoryListTaxation}></Product>
                    </div>
                </div>
            </div>
        </section>


    </>);
}

export default Index;